import { DASHBOARD_MENU_PLUGINS_DIR } from '@wix/cli-app-definitions';
import type { DevCenterComponent } from '../dev-center-component.js';
import { composeValidations, pathValidation } from './common.js';

function dashboardMenuPluginExistsValidation(
  existingDashboardMenuPlugins: Array<DevCenterComponent<'DashboardMenuPlugin'>>
) {
  return (folder: string) =>
    existingDashboardMenuPlugins.every(
      (dashboardMenuPlgin) =>
        folder !==
        dashboardMenuPlgin.relativePath
          .replace(`${DASHBOARD_MENU_PLUGINS_DIR}/`, '')
          .replace('/plugin.json', '')
    );
}

export function createDashboardMenuPluginValidation(
  dashboardMenuPlugins: Array<DevCenterComponent<'DashboardMenuPlugin'>>
) {
  return composeValidations([
    [
      dashboardMenuPluginExistsValidation(dashboardMenuPlugins),
      'The menu plugin folder must be unique, please choose a name that has not been used yet in your application.',
    ],
    [
      pathValidation,
      'The menu plugin folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}
